import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Actions can be used to reward players for linking their accounts, joining your Discord guild, Steam group, and more. "),
  /*#__PURE__*/_createElementVNode("span", { class: "high-em" }, "Every time a player is updated, their eligibility is calculated for all actions, after which the corresponding actions are invoked"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_2 = { class: "player__info" }
const _hoisted_3 = { class: "breadcrumbs overflow-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Integrations ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__item" }, " New Action ", -1)
const _hoisted_8 = { class: "player__created-date" }
const _hoisted_9 = { class: "dashboard__section" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Create an Action", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Create action ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_action_form = _resolveComponent("action-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "breadcrumbs__item",
          to: `/dashboard/${_ctx.$route.params.subdomain}/integrations`
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "breadcrumbs__item",
          to: `/dashboard/${_ctx.$route.params.subdomain}/integrations/${_ctx.integration?.id}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.integration?.name) + " (#" + _toDisplayString(_ctx.integration?.id) + ") ", 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_6,
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
        _createTextVNode(" Created " + _toDisplayString(_ctx.formattedDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_action_form, {
        ref: "actionForm",
        definitions: _ctx.definitions,
        modelValue: _ctx.action,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.action) = $event)),
        onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["definitions", "modelValue", "onSubmit"])
    ])
  ]))
}